'use strict';

bbw.service.LocState = ngtk.model.Abstract.extend({

    $rootScope: undefined,
    $location: undefined,
    $q: undefined,
    $timeout: undefined,

    _listenPath: undefined,
    _runDeferred: undefined,
    _defaultState: undefined,
    _states: undefined,
    _stateSearch: undefined,
    _isListening: false,
    _onStateChangedCb: undefined,
    _onStateNotFoundCb: undefined,
    _currentQuery: undefined,
    _currentState: undefined,
    _currentHash: undefined,
    _onHashChangedCb: undefined,
    _scope: undefined,
    prevent: undefined,

    construct: function($rootScope, $location, $q, $timeout, config) {
        if (!angular.isObject(config)) {
            throw new Error("Invalid config argument");
        }

        this.$rootScope = $rootScope;
        this.$location = $location;
        this.$q = $q;
        this.$timeout = $timeout;
        this.prevent = angular.isFunction(config.prevent) ? config.prevent : angular.noop;
        this._configureStates(config);
        this._onStateChangedCb = angular.isFunction(config.onStateChange) ? config.onStateChange : angular.noop;
        this._onStateNotFoundCb = angular.isFunction(config.onStateNotFound) ? config.onStateNotFound : angular.noop;
        this._currentState = this.find(this._setCurrentQueryFromWindowLocation()) || {};
        this._onHashChangedCb = angular.isFunction(config.onHashChange) ? config.onHashChange : angular.noop;
        this._scope = config.scope;
    },

    run: function(listenPath) {
        this._runDeferred = this.$q.defer();
        this.$timeout(function() {
            try {
                this._listen(angular.isString(listenPath) ? listenPath : undefined);
            } catch (e) {
                console.error(e);
                this._runDeferred && this._runDeferred.reject('' + e);
            }
        }.bind(this));

        return this._runDeferred.promise;
    },

    getCurrentState: function() {
        return this._currentState;
    },

    _listen: function(path) {
        if (this._isListening) {
            throw new Error('Already listening');
        }

        this.$rootScope.$on('$destroy', this._stopListening.bind(this));
        window.addEventListener('beforeunload', this._stopListening.bind(this));

        if (this._scope) {
            this._scope.$on('$destroy', this._stopListening.bind(this));
        }

        this._listenPath = path || this.$location.path();
        this.$rootScope.$on('$locationChangeStart', function(event, newValue) {
            if (!this._isListening) {
                return;
            }
            if (this.prevent()) {
                return;
            }
            var newUri = new Uri(newValue);
            if (newUri.path() !== this._listenPath) {
                return;
            }
            var newQuery = newUri.query().substr(1);
            var isQueryChanged = (newQuery !== this._currentQuery);
            if (isQueryChanged) {
                this._currentQuery = newQuery;
                this._setStateOnCurrentQueryChanged();
            }
            var newHash = newUri.anchor();
            if (angular.isString(newHash) && newHash.charAt(0) == '~') {
                newHash = newHash.substr(1);
            } else {
                newHash = '';
            }
            if (newHash !== this._currentHash) {
                this._currentHash = newHash;
                this._onHashChanged();
            }
        }.bind(this));

        this._isListening = true;
        this._setStateOnCurrentQueryChanged();
    },

    _setCurrentQueryFromWindowLocation: function() {
        var hash = window.location.hash.replace(/^#/, '');
        if (hash.charAt(0) == '~') {
            this._currentHash = hash.substr(1);
        } else {
            this._currentHash = '';
        }
        return this._currentQuery = this._getLocationSearchQuery();
    },

    _getLocationSearchQuery: function() {
        return window.location.search.substr(1);
    },

    _setStateOnCurrentQueryChanged: function() {
        var state = this.find(this._currentQuery);
        if (!state && this._defaultState) {
            this.go('' + this._defaultState[0], this._defaultState[1] || {}, this._defaultState[2] || {}, true);
        } else {
            this._setState(state);
        }
    },

    _setState: function(state) {
        if (state) {
            ngtk.tools.object.replace(this._currentState, state);
            this._onSetStateChangeSuccess();
        } else {
            this._onSetStateChangeFailure();
        }
    },

    _onSetStateChangeSuccess: function() {
        if (this._runDeferred) {
            this._runDeferred.resolve(this._currentState);
            this._runDeferred = undefined;
        }
        this._onStateChangedCb(this._currentState);
    },

    _onSetStateChangeFailure: function() {
        if (this._runDeferred) {
            this._runDeferred.reject(new Error('not_found'));
            this._runDeferred = undefined;
        }
        this._onStateNotFoundCb();
    },

    go: function(stateName, args, params, replace) {
        this.setState(stateName, args, params, replace);
    },

    setParams: function(params, replace, keepHash) {
        this.setState(undefined, this._currentState.args, angular.extend(angular.copy(this._currentState.params), params), replace, keepHash);
    },

    setState: function(stateName, args, params, replace, keepHash) {
        if (this.prevent()) {
            return;
        }
        if (this._listenPath !== this.$location.path()) {
            return;
        }
        if (angular.isUndefined(stateName)) {
            if (angular.isObject(this._currentState) && angular.isDefined(this._currentState.name)) {
                stateName = this._currentState.name;
            } else {
                throw new Error("stateName not given, and currentState.name is undefined");
            }
        }
        var state = this._states[stateName];
        if (!state) {
            throw new Error("State not registered: [" + stateName + "]");
        }
        var query = ngtk.tools.string.parseTemplate(state.template, this._escapeArgs(args)).split('{').filter(function(token) {
            return '}' !== token.substr(-1);
        }).join('');
        if (params) {
            var queryParams = [];
            angular.forEach(params, function(value, key) {
                if (angular.isDefined(value)) {
                    queryParams.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
                }
            });
            if (queryParams.length) {
                query += '&' + queryParams.join('&');
            }
        }
        this.$location.search(query);
        if (!keepHash && this.$location.hash()) {
            this.$location.hash('');
        }
        if (replace) {
            this.$location.replace();
        }
    },

    getHash: function() {
        return this._currentHash;
    },

    setHash: function(value, replace) {
        if (this.prevent()) {
            return;
        }
        if (this._listenPath !== this.$location.path()) {
            return;
        }
        if (this._currentHash === value) {
            return;
        }
        this.$location.hash('~' + (value || ""));
        if (replace) {
            this.$location.replace();
        }
    },

    _onHashChanged: function() {
        this._onHashChangedCb(this._currentHash);
    },

    _escapeArgs: function(args) {
        var result = {};
        angular.forEach(args || {}, function(value, key) {
            result[key] = encodeURIComponent(value);
        });
        return result;
    },

    _stopListening: function() {
        this._isListening = false;
    },

    _configureStates: function(config) {
        if (!angular.isObject(config.states)) {
            throw new Error("no states defined");
        }
        this._states = {};
        this._stateSearch = [];
        this._defaultState = angular.isArray(config.defaultState) ? config.defaultState : undefined;
        angular.forEach(config.states, function(match, stateName) {
            var compiledState = this._compileState(match, stateName);
            this._states[stateName] = compiledState;
            this._stateSearch.push(compiledState);
        }.bind(this));
        this._stateSearch.sort(function(a, b) {
            return b.prefixLen - a.prefixLen;
        });
    },

    find: function(query) {
        var match = {},
            tokens = ('' + query).trim().replace(/(^\/+)|\/+$/g, '').split('&');

        var search = tokens.shift();
        if (search.indexOf('=') >= 0) {
            tokens.unshift(search);
            search = '';
        }

        this._stateSearch.forEach(function(compiledState) {
            var matchResult = search.match(compiledState.regexp);
            if (!matchResult) {
                return;
            }
            if (angular.isUndefined(match.len) || matchResult[0].length > match.len) {
                match.matchedState = compiledState;
                match.matchResult = matchResult;
                match.len = matchResult[0].length;
            }
        });

        if (angular.isUndefined(match.matchedState)) {
            return undefined;
        }

        return {
            name: match.matchedState.stateName,
            args: match.matchedState.argNames.reduce(
                function(carry, name, index) {
                    return carry[name] = match.matchResult[index + 1], carry;
                }, {}),
            params: tokens.reduce(function(carry, arg) {
                var tokens = arg.split('=');
                if (tokens.length) {
                    var key = tokens.shift();
                    carry[key] = tokens.length ? tokens.join('=') : true;
                }
                return carry;
            }, {})
        };
    },

    _compileState: function(match, stateName) {
        var argNames = [];
        var regexpTokens = [];
        var templateTokens = [];
        var prefixLen = undefined;
        ('' + match).split(/(?=[{}])/).forEach(function(token) {
            var re;
            if (token === '}' || token === '') {
                return;
            }
            if (token.substr(0, 1) === '{' && (re = this._compileArgumentRegexp(token.substr(1)))) {
                argNames.push(re[0]);
                regexpTokens.push(re[1]);
                templateTokens.push('{' + re[0] + '}');
                if (angular.isUndefined(prefixLen)) {
                    prefixLen = 0;
                }
            } else {
                if (token.substr(0, 1) === '}') {
                    token = token.substr(1);
                }
                if (angular.isUndefined(prefixLen)) {
                    prefixLen = token.length;
                }
                regexpTokens.push(ngtk.tools.string.escapeRegexp(token));
                templateTokens.push(token);
            }
            return regexpTokens;
        }.bind(this));

        return {
            stateName: stateName,
            regexp: new RegExp('^' + regexpTokens.join('')),
            template: templateTokens.join(''),
            argNames: argNames,
            prefixLen: prefixLen
        };
    },

    _compileArgumentRegexp: function(argumentRegexp) {
        var tokens = argumentRegexp.split(':');
        if (tokens.length < 1) {
            return undefined;
        }
        var argName = tokens.shift();
        var regexpMatch = tokens.join(':') || '.+';
        return [argName, '(' + regexpMatch + ')'];
    },

    _wireScope: function(scope, scopeInnerPtr, scopeInnerElement) {
        scopeInnerPtr[scopeInnerElement] = this._currentState;
    }

});
